import React, {
  useEffect,
  useState,
  useContext
} from "react";
import style from "../../../styles/mystyle.module.css";
import { useTranslation } from "next-i18next";

import { styled, margin } from "@mui/system";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import EditIcon from "@mui/icons-material/Edit";
import PlaceIcon from "@mui/icons-material/Place";
import Select from "@mui/material/Select";
import config from "../../../next.config.js";
import { useRouter } from "next/router";
import { printLogs } from "../../helpers/helpers";
import { getTermsByVocabCodes } from "../../helpers/global/term/term";
import MenuItem from "@mui/material/MenuItem";
import TermsContext from "../../../context/Trems";
import axios from "axios";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import AddIcon from "@mui/icons-material/Add";
import FromControlLabel from "@mui/material/FormControlLabel";
import { constants } from "../../../constants";
import FormHelperTxet from "@mui/material/FormHelperText";
import LoadingJSON from "../Loaders/Loading";
import { Skeleton } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs';
// import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
const CustomeFormControl = styled(FormControl)({
  border: " 2px solid #eaeaea",
  borderRadius: "8px",
  width: "100%",
  margin: "0px !important",
  backgroundColor: "white",
  "& label.Mui-focused": {
    color: "#02AAB0"
  },

  "& .MuiOutlinedInput-root": {
    height: "100%",
    //color: "#02AAB0",
    fontSize: "1rem !important",
    cursor: "pointer !important"
  },
  "& .MuiIconButton-root": {
    color: "#02AAB0"
  },
  "& .MuiSelect-icon": {
    color: "#02AAB0"
  },
  "& .MuiInputLabel-root": {
    cursor: "pointer !important",
    fontSize: "1rem !important"
  },
  "& .MuiOutlinedInput-input.Mui-disabled": {
    color: "black !important",
    WebkitTextFillColor: "black",
    cursor: "pointer !important"
  },   
  "@media only screen and  (min-width:280px)": {
    "& .MuiOutlinedInput-root": {
      cursor: "pointer !important",
      fontSize: "1rem !important",

    },
    "& .MuiInputLabel-root": {
      cursor: "pointer !important",
      fontSize: "1rem !important"
    },

  },
  "@media (min-width:768px) and (max-width:912px)": {
    "& .MuiOutlinedInput-root": {
      cursor: "pointer !important",
      fontSize: "1.2rem !important"
    },
    "& .MuiInputLabel-root": {
      cursor: "pointer !important",
      fontSize: "1.2rem !important"
    }
  }
});
const CustomeAccordion = styled(Accordion)({
  "& .MuiSvgIcon-root ": {
    color: "#02AAB0"
  },
  "& .MuiAccordion-root": {
    boxShadow: "0 0 4px #bcbcbc",
    margin: " 7px 0px"
  },
  //  '&:first-of-type':{
  margin: " 7px 0px",
  //  },
  "&:second-of-type": {
    margin: " 7px 0px"
  }
});
const Customeselect = styled(Select)(({ theme, locale }) => ({
  "& .MuiSelect-select": {
    textAlign: locale == "ar" ? "right" : "left"
  },
  "& .MuiSelect-root": {
    borderRadius: "8px"
  }
}));
const CustomeTextField =  styled(DateTimePicker)(({ theme, locale }) => ({
  border: " 2px solid #eaeaea",
  borderRadius: "8px",
  width: "100%",
  padding:"0px 10px",
  backgroundColor: "white",
  '& .MuiPaper-root .MuiPickersYear-root.Mui-selected':{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  '& .MuiPaper-root .MuiPickersDay-root':{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  '& .MuiPaper-root .MuiPickersYear-yearButton':{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  '& .dateTimePicker .MuiButtonBase-root-MuiPickersDay-root.Mui-selected': {
    backgroundColor: "#F52A59 !important",
    color: "white",
},
'& .dateTimePicker .MuiPickersYear-yearButton': {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
},
'& .MuiButtonBase-root-MuiPickersDay-root.Mui-selected:hover': {
    backgroundColor: "#F52A59 !important",
},
"& .MuiMultiSectionDigitalClockSection-item.Mui-selected":{
  backgroundColor: "#F52A59 !important",
  color: "white",
},
  
}));
const CustomeBg = styled("div")`
  background-image: url(${props => props.img});
`;
function Address(props) {
  const [value, setValue] =useState(dayjs('2022-04-17T15:30'))
  const vocabTerms = useContext(TermsContext);
  const { t } = useTranslation("common");
  let limit = 50;
  const [pageId, setpageId] = useState(1);
  const [purchaseOrderTypes, setPurchaseOrderTypes] = useState([]);
  const [OrderAddress, setOrderAddress] = useState([]);
  const [SelectAddresses, setSelectAddresses] = useState({
    Address: null,
    Address_from: null
  });
  const [SelectOrderType, setSelectOrderType] = useState(null);
  const [DeliveryPrice, setDeliveryPrice] = React.useState(null);
  const [DeliveryPriceError, setDeliveryPriceError] = React.useState(null);
  const [loading, setloading] = React.useState(false);
  const [ExpandedFrom, setExpandedFrom] = React.useState(false);
    const [ExpandedTo, setExpandedTo] = React.useState(false);
  // const [DialogDataMap, setDialogDataMap] = useState({
  //   open: false,
  //   Type: " "
  // });
  // const TimeNow = new Date().getTime();
  const handleChange = e => {
    let values = { errorArray: {} };
    if(e.target){
    if (e.target.name == "Address_from" || e.target.name == "Address") {
      let temp = { ...SelectAddresses };
      temp[e.target.name] = e.target.value;
      values["errorArray"]["DeliveryPrice"]=false
      setSelectAddresses(temp);
      if (temp && temp.Address != null && temp.Address_from != null && temp.Address_from != temp.Address) {
        setDeliveryPrice(null);
        setDeliveryPriceError(null);
        setloading(true);
        let AddressToValue = OrderAddress.filter(i => i.id == temp.Address)[0];
        let AddressFromValue = OrderAddress.filter(
          i => i.id == temp.Address_from
        )[0];


        let SearchData = {data:{
          destinationLatitude: AddressToValue.latitude,
          destinationLongitude: AddressToValue.longitude,
          sourceLongitude: AddressFromValue.longitude,
          sourceLatitude: AddressFromValue.latitude
        },url:"/api/shipping/v2/distanceMatrix/getDistance"};

        axios
          .post(`${config["basePath"]}/api/orders/shipping/getDistance`, {
            data: SearchData,
            headers: {
              "Content-Type": "application/json",
              "accept-language": router.locale
            }
          })
          .then(respDistance => {
            
            setloading(false);
            if (respDistance.data.data && !respDistance.data.data.errors) {
              
              values["DeliveryPrice"] =respDistance.data.data;
              values["errorArray"]["DeliveryPrice"]=false
               
      
              let currency = respDistance.data.data.currency[0].transCurrency.filter(
                i => i.language.code == router.locale
              )[0];
         
              setDeliveryPrice({
                Price: respDistance.data.data.priceAfterDiscount,
                currency: currency
              });
            } else {
              values["errorArray"]["DeliveryPrice"]=true
              setDeliveryPriceError(
                respDistance.data.data.errors.subErrors[0].message
              );

            
            }
            props.callbackInputsValues(values);
          })
          .catch(err => ("err==================>", err));
      }
      else{setDeliveryPrice(null)}
    }
    if (e.target.name == "PurchaseOrderType" && e.target.value) {
      values["errorArray"][e.target.name] = false;
      values[e.target.name] = purchaseOrderTypes.filter(
        i => i.id == e.target.value
      )[0];
      setSelectOrderType(purchaseOrderTypes.filter(
        i => i.id == e.target.value
      )[0])
    } else {
      setSelectOrderType(null)
      values["errorArray"][e.target.name] = false;
      values[e.target.name] = e.target.value;
    }
  }else{
    values["errorArray"]["deliveryDate"] = false;
    values["deliveryDate"] = e;
  }
  values["OrderAddress"]=OrderAddress
  props.callbackInputsValues(values);
  };
  useEffect(() => {}, [props.errors]);
  useEffect(() => {
    getTermsByVocabCodes(["order-package-types"]).then(res => {

      setPurchaseOrderTypes(
        JSON.parse(res).filter(i => i.language.code == router.locale&&vocabTerms.statusIds.includes(i.statusId))
      );
    });
    let SearchData = {
      limit: limit,
      pageId: pageId,
      statusId: vocabTerms.statusIds
    };
    axios
      .get(`${config["basePath"]}/api/orders/addresses/get`, {
        params: SearchData,
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(res => {
        if (pageId > 1) {
          setOrderAddress(prevState => [...prevState, ...res.data.data.data]);
        } else {
          setOrderAddress([...res.data.data.data]);
        }
        if (limit == res.data.data.pageable.numberOfElements) {
          if (limit * pageId < res.data.data.pageable.totalElements) {
            let temp = pageId + 1;
            setpageId(temp);
            axios
              .get(`${config["basePath"]}/api/orders/addresses/get`, {
                params: {
                  limit: limit,
                  pageId: temp
                },
                headers: {
                  "Content-Type": "application/json"
                }
              })
              .then(res => {
                setOrderAddress(prevState => [
                  ...prevState,
                  ...res.data.data.data
                ]);
              })
              .catch(err => err);
          }
        }
      })
      .catch(err => err);
  }, []);
  const router = useRouter();
  return (
    <>
      <div className={style.BackgroundGreySquare}>
        <CustomeBg
          img={`${config.basePath}/assest/SquareBackground.png`}
          className={style.BackgroundGreySquare}
        >
          <div className={style.SectionContainer + " " + style.paddinglrzero}>
            <div>
              <div
                className={style.SectionContainer + " " + style.PaddingTopZero + " " + style.paddinglrzero}
              >
                <div className={style.allcard}>
                  <div className={style.BgComp}>
                    <div className={style.towOrderMedicineDiv}>
                      {purchaseOrderTypes && purchaseOrderTypes.length > 0 ? (
                        <CustomeFormControl
                          sx={{
                            direction: router.locale == "ar" ? "rtl" : "ltr",
                            alignItems: "right"
                          }}
                        >
                          <InputLabel htmlFor="OrderType">
                            {" "}
                            {t("OrderType")}
                          </InputLabel>
                          <Customeselect
                            label="PurchaseOrderType"
                            name="PurchaseOrderType"
                            onChange={e => {handleChange(e)}}
                          >
                            {purchaseOrderTypes && purchaseOrderTypes.length > 0
                              ? purchaseOrderTypes.map(type => (
                                  <MenuItem
                                    style={{
                                      direction:
                                        router.locale == "ar" ? "rtl" : "ltr",
                                      alignItems: "right"
                                    }}
                                    value={type.id}
                                    key={type.id}
                                  >
                                    {type.name}
                                  </MenuItem>
                                ))
                              : ""}
                          </Customeselect>
                        </CustomeFormControl>
                      ) : (
                        ""
                      )}

                      {props.errors.PurchaseOrderType.value ? (
                        <FormHelperTxet
                          style={{ textAlign: "center" }}
                          error={props.errors.PurchaseOrderType.value}
                        >
                          {props.errors.PurchaseOrderType.message}
                        </FormHelperTxet>
                      ) : (
                        ""
                      )}
                      {/* <CustomeTextField
                        style={{
                          direction: router.locale == "ar" ? "rtl" : "ltr",
                          alignItems: "right"
                        }}
                        onopen={true}
                        name="deliveryDate"
                        onChange={handleChange}
                        type="datetime-local"
                        label={t("BestTime")}
                        defaultValue={"2023-02-2T10:50"}
                        InputLabelProps={{ shrink: true }}
                      /> */}
                       <LocalizationProvider 
                       dateAdapter={AdapterDayjs}
                       adapterLocale={router.locale == "ar" ? "ar" : "en"}  >
      {/* <DemoContainer components={['DateTimePicker']}> */}
        <CustomeTextField
     
        className={"dateTimePicker"}
               localeText={router.locale == "ar" ? "ar" : "en"}
          label={t("BestTime")}
          name="deliveryDate"
          locale={router.locale}
          defaultValue={dayjs()}
          format="DD/MM/YYYY HH:MM A"
          // name="deliveryDate"
          onChange={handleChange}
          minDate={dayjs()}
        />
        {/* <DateTimePicker
          label="Controlled picker"
          value={value}
          onChange={(newValue) => setValue(newValue)}
        /> */}
      {/* </DemoContainer> */}
    </LocalizationProvider>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={
                  style.SectionContainer + " " + style.paddingBottomZero
                }
              >
                <div className={style.allcard}>
                  <div className={style.BgComp}>
                    <div className={style.towOrderMedicineDiv}>
                      <div
                        className={
                          style.hLine7 +
                          "  " +
                          style.paddingzero +
                          " " +
                          style.Blod +
                          " " +
                          style.TealColor
                        }
                      >
                        {t("TheAddress")}
                      </div>

                      <CustomeAccordion expanded={ExpandedFrom}
                        defaultExpanded={false}
                        onChange={ (e)=>{setExpandedFrom(!ExpandedFrom)}}
                        >
                        <AccordionSummary
                          expandIcon={
                            OrderAddress && OrderAddress.length > 0 ? (
                              <EditIcon />
                            ) : (
                              <AddIcon
                                onClick={() => {
                                  let data = { next: router.asPath };
                                  router.push({
                                    pathname: constants.AddAddress,
                                    query: data
                                  });
                                }}
                              />
                            )
                          }
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <InputAdornment
                            position="start"
                            sx={{ marginTop: "8px" }}
                          >
                            <PlaceIcon className={style.TealColor} />
                          </InputAdornment>
                          <Typography>   {OrderAddress && OrderAddress.length &&OrderAddress.filter(i=>i.id== SelectAddresses.Address_from).length>0 && ExpandedFrom==false?OrderAddress &&OrderAddress.filter(i=>i.id== SelectAddresses.Address_from)[0].name:t("address-from")  }{"    "} {"   "}
                        
                          <span style={{color:"#008C8D" }}>{SelectOrderType!=null ? SelectOrderType &&SelectOrderType.field3 && SelectOrderType.field3==1? ` (  ${t("mandatory-field")}  )` : ` (  ${t("optional-field")} )`:"" }</span>
                          </Typography>
                        </AccordionSummary>

                        <AccordionDetails sx={{ textAlign: "initial" }}>
                     
                          {OrderAddress.length > 0 
                            ? OrderAddress.map(item => (
                                <div>
                                  <FromControlLabel
                                  sx={{marginTop:1,marginBottom:1}}
                                    control={
                                      <Radio
                                        checked={
                                          SelectAddresses.Address_from ==
                                          item.id
                                            ? true
                                            : false
                                        }
                                        onChange={e => {handleChange(e),setExpandedFrom(false)}}
                                        value={item.id}
                                        name="Address_from"
                                      />
                                    }
                                    label={
                                      <React.Fragment>
                                          {item.name}
                                        <div>{item.address}</div>
                                      
                                      </React.Fragment>
                                    }
                                  />
                                </div>
                              ))
                            : ""}
                          <hr />
                          <div>
                            <FromControlLabel
                              onClick={() => {
                                let data = { next: router.asPath };
                                router.push({
                                  pathname: constants.AddAddress,
                                  query: data
                                });
                              }}
                              control={<AddIcon sx={{ margin: "0px 10px" }} />}
                              label={
                                <React.Fragment>
                                  {t("AddAddress")}
                                </React.Fragment>
                              }
                            />
                          </div>
                        </AccordionDetails>
                      </CustomeAccordion>
                      {props.errors.Address_from.value ? (
                        <FormHelperTxet
                          style={{ textAlign: "center" }}
                          error={props.errors.Address_from.value}
                        >
                          {props.errors.Address_from.message}
                        </FormHelperTxet>
                      ) : (
                        ""
                      )}

         <CustomeAccordion
                        expanded={ExpandedTo}
                        defaultExpanded={false}
                        onChange={ (e)=>{setExpandedTo(!ExpandedTo)}}>
                        <AccordionSummary
                          expandIcon={
                            OrderAddress && OrderAddress.length > 0   ? (
                              <EditIcon />
                            ) : (
                              <AddIcon
                                onClick={() => {
                                  let data = { next: router.asPath };
                                  router.push({
                                    pathname: constants.AddAddress,
                                    query: data
                                  });
                                }}
                              />
                            )
                          }
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <InputAdornment
                            position="start"
                            sx={{ marginTop: "8px" }}
                          >
                            <PlaceIcon className={style.TealColor} />
                          </InputAdornment>
                          <Typography>{OrderAddress && OrderAddress.length &&OrderAddress.filter(i=>i.id== SelectAddresses.Address).length>0  && ExpandedTo==false?OrderAddress &&OrderAddress.filter(i=>i.id== SelectAddresses.Address)[0].name:t("address-to")}</Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ textAlign: "initial" }}>
                          {OrderAddress.length >  0 
                            ? OrderAddress.map(item => (
                                <div>
                                  <FromControlLabel
                                        sx={{marginTop:1,marginBottom:1}}
                                    control={
                                      <Radio
                                        checked={
                                          SelectAddresses.Address == item.id
                                            ? true
                                            : false
                                        }
                                        onChange={e => {handleChange(e),setExpandedTo(false)}}

                                        value={item.id}
                                        name="Address"
                                      />
                                    }
                                    label={
                                      <React.Fragment>
                                        {item.name}
                                      <div>{item.address}</div>
                                      
                                    </React.Fragment>
                                    }
                                  />
                                </div>
                              ))
                            : ""}
                          <hr />
                          <div>
                            <FromControlLabel
                              onClick={() => {
                                let data = { next: router.asPath };
                                router.push({
                                  pathname: constants.AddAddress,
                                  query: data
                                });
                              }}
                              control={<AddIcon sx={{ margin: "0px 10px" }} />}
                              label={
                                <React.Fragment>
                                  {t("AddAddress")}
                                </React.Fragment>
                              }
                            />
                          </div>
                        </AccordionDetails>
                      </CustomeAccordion>

                      {props.errors.Address.value ? (
                        <FormHelperTxet
                          style={{ textAlign: "center" }}
                          error={props.errors.Address.value}
                        >
                          {props.errors.Address.message}
                        </FormHelperTxet>
                      ) : (
                        ""
                      )}
                       {props.errors.Addresses.value ? (
                          <FormHelperTxet
                            style={{ textAlign: "center" }}
                            error={props.errors.Addresses.value}
                          >
                            {props.errors.Addresses.message}
                          </FormHelperTxet>
                        ) : (
                          ""
                        )}
                      {DeliveryPrice && DeliveryPrice != null ? (
                        <div className={style.h1s7} style={{ textAlign: "center" }}>
                          {t("DeliveryPrice") + " = "}
                          {DeliveryPrice.Price}
                          {DeliveryPrice.currency.currencySymbol}
                        </div>
                      ) : (
                          ""
                        )}
                      {DeliveryPriceError && DeliveryPriceError != null ? (
                        <div className={style.h1s7}
                          style={{ textAlign: "center",color:"#f52a59" }}
                          error={true}
                        >
                          {DeliveryPriceError}
                        </div>
                      ) : (
                          ""
                        )}
                      {loading && (
                        <div style={{ textAlign: "center" }}>
                          <Skeleton width="30%" className={style.marginAuto} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>{" "}
          </div>
        </CustomeBg>
      </div>
    </>
  );
}

export default Address;
